module.exports = __webpack_public_path__ + "img/黑蒙版左.c02ff5fe.png";